import { Box, Button, Typography, Paper, IconButton } from '@mui/material';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import React from 'react';
import { useTranslation } from '../../../hooks/useTranslation';

interface ExpertSelectionStepProps {
    onSelectExpert: () => void;
    onBack: () => void;
}

const ExpertSelectionStep: React.FC<ExpertSelectionStepProps> = ({ onSelectExpert, onBack }) => {
    const { t } = useTranslation();

    const steps = [
        { title: t('onboarding.expert.steps.step1.title'), description: t('onboarding.expert.steps.step1.description') },
        { title: t('onboarding.expert.steps.step2.title'), description: t('onboarding.expert.steps.step2.description') },
        { title: t('onboarding.expert.steps.step3.title'), description: t('onboarding.expert.steps.step3.description') },
        { title: t('onboarding.expert.steps.step4.title'), description: t('onboarding.expert.steps.step4.description') },
    ];

    return (
        <Box
            sx={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                flex: 1,
                py: 1,
                minHeight: '400px',
                position: 'relative',
            }}
        >
            <IconButton
                onClick={onBack}
                sx={{
                    position: 'absolute',
                    top: 0,
                    left: 0,
                    color: 'text.secondary',
                    '&:hover': {
                        backgroundColor: 'action.hover',
                    },
                }}
                aria-label="Go back"
            >
                <ArrowBackIcon />
            </IconButton>
            
            <Typography
                variant="h5"
                sx={{
                    mb: 3,
                    fontWeight: 600,
                    textAlign: 'center',
                }}
            >
                {t('onboarding.expert.description')}
            </Typography>

            <Paper
                elevation={0}
                sx={{
                    p: 4,
                    border: '1px solid',
                    borderColor: 'divider',
                    borderRadius: 2,
                    backgroundColor: 'background.paper',
                    maxWidth: '700px',
                    width: '100%',
                    mb: 3,
                }}
            >
                {steps.map((step, index) => (
                    <Box key={index} sx={{ mb: index < steps.length - 1 ? 4 : 0 }}>
                        <Typography
                            variant="subtitle1"
                            sx={{
                                fontWeight: 600,
                                mb: 0.5,
                                color: 'primary.main',
                                fontSize: '1rem',
                            }}
                        >
                            {step.title}
                        </Typography>
                        <Typography
                            variant="body2"
                            sx={{
                                color: 'text.secondary',
                                lineHeight: 1.4,
                                fontSize: '0.875rem',
                            }}
                        >
                            {step.description}
                        </Typography>
                    </Box>
                ))}
            </Paper>

            <Button
                variant="contained"
                size="large"
                onClick={onSelectExpert}
                sx={{
                    mt: 2,
                    px: 4,
                    py: 1.5,
                    fontSize: '1.1rem',
                    fontWeight: 600,
                    borderRadius: 2,
                }}
            >
                {t('onboarding.expert.selectButton')}
            </Button>
        </Box>
    );
};

export default ExpertSelectionStep;